import { FIXED_TIMESTEP_MS, MAX_CATCHUP_STEPS } from '@hamsters/game-config';

export class Time {
  private lastTime = 0;
  private accumulator = 0;
  private _delta = 0;
  private _tick = 0;
  private _fps = 0;
  private _fpsAccumulator = 0;
  private _fpsFrameCount = 0;
  private paused = false;

  readonly fixedStep = FIXED_TIMESTEP_MS / 1000;

  get delta(): number {
    return this._delta;
  }

  get tick(): number {
    return this._tick;
  }

  get fps(): number {
    return this._fps;
  }

  get isPaused(): boolean {
    return this.paused;
  }

  start(): void {
    this.lastTime = performance.now() / 1000;
    this.accumulator = 0;
  }

  update(): number {
    const now = performance.now() / 1000;
    this._delta = Math.min(now - this.lastTime, 0.1);
    this.lastTime = now;

    if (this.paused) return 0;

    this.accumulator += this._delta;

    let steps = 0;
    while (this.accumulator >= this.fixedStep && steps < MAX_CATCHUP_STEPS) {
      this.accumulator -= this.fixedStep;
      this._tick++;
      steps++;
    }

    // FPS counter
    this._fpsAccumulator += this._delta;
    this._fpsFrameCount++;
    if (this._fpsAccumulator >= 1) {
      this._fps = this._fpsFrameCount;
      this._fpsFrameCount = 0;
      this._fpsAccumulator = 0;
    }

    return steps;
  }

  pause(): void {
    this.paused = true;
  }

  resume(): void {
    this.paused = false;
    this.lastTime = performance.now() / 1000;
    this.accumulator = 0;
  }

  get alpha(): number {
    return this.accumulator / this.fixedStep;
  }
}
